import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { grantMatch2Rewards } from '../match2/match2.modifiers';
import {
  resurrectionFiftyGemsReward,
  resurrectionHundredGemsReward,
  resurrectionMigrationGemsReward,
  resurrectionRewards,
} from './resurrection.ruleset';
import { isReactivated } from './resurrection.getters';
import { claimResurrectionReward } from './resurrection.modifiers';
import { revivePet } from '../pet/pet.modifiers';
import { sendAnalyticsEvents } from '../analytics';

export const resurrectionActions = createActions({
  grantResurrectionRewards: action((state, _, api) => {
    if (!isReactivated(state, api.date.now())) {
      return;
    }

    grantMatch2Rewards(
      state,
      resurrectionRewards,
      {
        feature: 'resurrection',
      },
      api,
    );
  }),

  /**
   * Grant resurrection gems reward if the user has received the gems reward OA
   */
  claimResurrectionGems: action((state, _, api) => {
    // Attempt to claim the resurrection item
    const claimed = claimResurrectionReward(
      state,
      'hundredGems',
      api.date.now(),
    );

    // Do nothing if item was not claimed
    if (!claimed) return false;

    // Grant the gems reward
    grantMatch2Rewards(
      state,
      [resurrectionHundredGemsReward],
      {
        feature: 'resurrect',
      },
      api,
    );

    // Item claimed
    return true;
  }),

  /**
   * Revive pet if the user can claim the revive pet resurrection
   */
  claimResurrectionRevivePet: action((state, _, api) => {
    // Attempt to claim the resurrection item
    const claimed = claimResurrectionReward(state, 'revivePet', api.date.now());

    // Do nothing if item was not claimed
    if (!claimed) return false;

    // Revive user's pet
    const revived = revivePet(state, api.date.now());

    // Send analytics event only if pet has actually been revived
    if (revived) {
      sendAnalyticsEvents(api, [
        {
          eventType: 'PetRevive',
          eventProperties: {
            feature: 'resurrect',
          },
        },
      ]);
    }

    // Item claimed
    return true;
  }),

  /**
   * Grant resurrection migration ToS gems reward if the user has received the gems reward OA
   */
  claimResurrectionMigrationGems: action((state, _, api) => {
    // Attempt to claim the resurrection item
    const claimed = claimResurrectionReward(
      state,
      'migrationGems',
      api.date.now(),
    );

    // Do nothing if item was not claimed
    if (!claimed) return false;

    // Grant the gems reward
    grantMatch2Rewards(
      state,
      [resurrectionMigrationGemsReward],
      {
        feature: 'resurrect',
      },
      api,
    );

    // Item claimed
    return true;
  }),

  /**
   * Grant 50-gem reward if the user has received the bear apology OA
   */
  claimResurrectionFiftyGemsBear: action((state, _, api) => {
    // Attempt to claim the resurrection item
    const claimed = claimResurrectionReward(
      state,
      'fiftyGemsBear',
      api.date.now(),
    );

    // Do nothing if item was not claimed
    if (!claimed) return false;

    // Grant the gems reward
    grantMatch2Rewards(
      state,
      [resurrectionFiftyGemsReward],
      {
        feature: 'resurrect',
      },
      api,
    );

    // Item claimed
    return true;
  }),

  /**
   * Grant 50-gem reward if the user has received the bear+capybara apology OA
   */
  claimResurrectionFiftyGemsBearCapy: action((state, _, api) => {
    // Attempt to claim the resurrection item
    const claimed = claimResurrectionReward(
      state,
      'fiftyGemsBearCapy',
      api.date.now(),
    );

    // Do nothing if item was not claimed
    if (!claimed) return false;

    // Grant the gems reward
    grantMatch2Rewards(
      state,
      [resurrectionFiftyGemsReward],
      {
        feature: 'resurrect',
      },
      api,
    );

    // Item claimed
    return true;
  }),
});
